import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useFormStepContext } from '../../FormStepContext'
import { SettingItem } from './SettingItem'

interface IndividualResultsSwitchProps {
  number: number
}

export const IndividualResultsSwitch: React.FC<IndividualResultsSwitchProps> = ({ number }) => {
  const { control } = useFormContext()
  const { isEdit } = useFormStepContext()

  const t_individualResults = useLocaleText('t_individualResults')

  return (
    <SettingItem
      number={number}
      title={t_individualResults}
      isDisabled={isEdit}
      control={
        <Controller
          as={ControlledCustomSwitch}
          name="is_individual_results"
          control={control}
          valueName="isChecked"
          size="lg"
          onChange={([event]) => {
            return event.target.checked
          }}
        />
      }
    />
  )
}
